module.exports = {
    // SearchBarExt
    'Объекты': 'Objects',
    'Адрес': 'Address',
    'По вашему запросу ничего не найдено': 'No results for this search query',
    'Произошла ошибка на стороне сервера': 'Server error',
    'Слой карты': 'Map layer',
    // Measurement
    'км<sup>2</sup>': 'km<sup>2</sup>',
    'м<sup>2</sup>': 'm<sup>2</sup>',
    'км': 'km',
    'м': 'm',
    // ChartLegend
    'Другие': 'Other',
    // Balloon
    'Закрыть': 'Close',
    // BaseLayer
    'Участники OpenStreetMap': 'OpenStreetMap contributors',
    'Спутник': 'Sputnik',
    'Ростелеком': 'Rostelecom',
    'Сменить формат координат': 'Change coordinate format'
};


//////////////////
// WEBPACK FOOTER
// ./src/View/i18n/en.js
// module id = 240
// module chunks = 0